import { Missing } from "../../molecules/Cells/Missing"
import { TextCell } from "../../molecules/Cells/TextCell"

type Props = {
  value?: number
}

export const ScientificNumberCell = ({ value }: Props) => {
  if (!value) return <Missing />

  const absValue = Math.abs(value)
  const formattedValue =
    absValue > 1 && absValue < 1000 ? value.toFixed(2) : value.toExponential(2)
  return <TextCell value={formattedValue ?? undefined} />
}
